import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckListIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <rect
        x="3.75"
        y="3.75"
        width="16.5"
        height="17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </SvgIcon>
  )
}

export default CheckListIcon
